// extracted by mini-css-extract-plugin
module.exports = {"activityRow":"styles_activityRow__3mJMZ","activityIcon":"styles_activityIcon__12qMu","edlightBlue":"styles_edlightBlue__3uz_p"};